module.exports = __webpack_public_path__ + "static/media/success.3751f921.svg";